import {
    createTable,
    PaginationState,
    SearchState,
    TableHeaderSpec
} from "../../../../../components/table/CreateTable.tsx";
import {SecondaryButton} from "../../../../../components/general/SecondaryButton.tsx";


export interface BankAccount {
    id: string,
    relation_name: string
    relation_iban: string
}

interface Props {
    data: Array<any>,
    onAddClick: (account: BankAccount) => void,
    tablePaginationState: [
        paginationState: PaginationState<BankAccount>,
        setPaginationState: (paginationState: any) => void
    ]
}

export function BankAccountsTable({data, onAddClick, tablePaginationState}: Props) {

    const tableSpec: TableHeaderSpec<BankAccount> = {
        title: `${data.length} Relaties`,
        columns: [
            {
                name: 'Name',
                field: 'name',
                customRender: (row: BankAccount) => (
                    <div className="">
                        <p>{row.relation_name}</p>
                        <p className={'font-mono'}>{row.relation_iban}</p>
                    </div>
                )
            },
            {
                name: '',
                field: '_',
                customRender: (row: BankAccount) => (
                    <div className="flex justify-end">
                        <SecondaryButton title={'Toevoegen'} onClick={() => onAddClick(row)}
                                         className="bg-transparent py-1 text-gray-500 hover:text-gray-700"/>
                    </div>
                )
            }
        ],
        pagination: {
            inMemory: true,
            paginationState: tablePaginationState,
            totalPages: Math.ceil(data.length / 5),
            defaultPageSize: 5,
        },
        search: {
          searchFn: (row: BankAccount, searchState: SearchState) => row?.relation_name?.toLowerCase().includes(searchState.currentQuery.toLowerCase())
        },
        options: {
            hideTableHeader: true,
            disableTopPaginationWidget: true,
            disableBottomPaginationWidget: true
        }
    }

    const TableComponent = createTable<BankAccount>(data, tableSpec)

    return (
        <>
            {TableComponent()}
        </>
    )
}
